/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userexternalid2Inputs */

const en_entity_userexternalid2 = /** @type {(inputs: Entity_Userexternalid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External ID`)
};

const de_entity_userexternalid2 = /** @type {(inputs: Entity_Userexternalid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe ID`)
};

/**
* | output |
* | --- |
* | "External ID" |
*
* @param {Entity_Userexternalid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userexternalid2 = /** @type {((inputs?: Entity_Userexternalid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userexternalid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userexternalid2(inputs)
	return de_entity_userexternalid2(inputs)
});
export { entity_userexternalid2 as "entity_userExternalId" }